import { Logger } from "@wemade-vsf/core";
const saveBillingAddressCommand = {
  execute: async (context, cartId, billingDetails, customQuery, customHeaders) => {
    var _a, _b, _c;
    const {
      apartment,
      neighborhood,
      extra,
      sameAsShipping,
      customerAddressId,
      ...address
    } = billingDetails;
    const billingData = customerAddressId ? { customer_address_id: customerAddressId } : {
      address: {
        ...address,
        street: [address.street, apartment, neighborhood, extra].filter(Boolean)
      },
      same_as_shipping: sameAsShipping
    };
    const setBillingAddressOnCartInput = {
      cart_id: cartId,
      billing_address: billingData
    };
    const { data } = await context.$vsf.$magento.api.setBillingAddressOnCart(
      setBillingAddressOnCartInput,
      customQuery,
      customHeaders
    );
    Logger.debug("[Result]:", { data });
    return (_c = (_b = (_a = data == null ? void 0 : data.setBillingAddressOnCart) == null ? void 0 : _a.cart) == null ? void 0 : _b.billing_address) != null ? _c : null;
  }
};
export {
  saveBillingAddressCommand
};
